document.addEventListener("DOMContentLoaded", function () {
    if(typeof lottie !== 'undefined'){
        // Set the path to your Lottie JSON file
        const animationPath = "./wp-content/themes/troxy/dist/images/lottie/troxy_brandmark_lottie.json";

        // Set up Lottie options
        const animationOptions = {
            container: document.getElementById("lottie-brandmark"),
            renderer: "svg", // or "canvas"
            loop: false,
            autoplay: false, // Autoplay is set to false initially
            path: animationPath,
        };

        // Initialize the Lottie animation
        const animation = lottie.loadAnimation(animationOptions);

        // Play the animation on hover
        document.getElementById("lottie-brandmark").addEventListener("mouseenter", function () {
            // console.log('hovering');
            animation.play();
        });

        // Pause the animation when not hovering
        document.getElementById("lottie-brandmark").addEventListener("mouseleave", function () {
            animation.goToAndStop(0);
        });

        // Scroll to the "upcoming" section on click
        document.getElementById("lottie-brandmark").addEventListener("click", function () {
            // console.log('clicked');
            // Replace "upcoming" with the actual id of your target section
            const upcomingSection = document.getElementById("upcoming");

            // Scroll smoothly to the upcoming section
            upcomingSection.scrollIntoView({ behavior: "smooth" });
        });
    }
});